import router from 'next/router'
import { eventClick } from '@smuchile/pkg-unimarc-hooks'

export const getSettingsOrderDetail = () => {
  const handleLogout = () => {
    eventClick({
      event: 'interacciones-mis-compras',
      eventCategory: 'menu',
      event_label: 'cerrar sesion'
    })

    const { pathname, query } = router
    router.push(
      {
        pathname,
        query: {
          ...query,
          logout: 'true'
        }
      },
      undefined,
      { shallow: true }
    )
  }

  const handleHomeEvent = () => {
    eventClick({
      event: 'interacciones-mis-compras',
      eventCategory: 'menu',
      event_label: 'mis compras'
    })
  }

  const handleListsEvent = () => {
    eventClick({
      event: 'interacciones-mis-compras',
      eventCategory: 'menu',
      event_label: 'mis listas'
    })
  }

  return {
    handleHomeEvent,
    handleListsEvent,
    handleLogout
  }
}
